import axios from "axios";
const localhost_env = localStorage.getItem('localhost_env');

const customFtech = axios.create({
    baseURL: localhost_env ? 'http://localhost:3001/pokeland-api/' : 'https://backend.pokeland-legends.club/pokeland-api/'
})

export default customFtech